import React from 'react';

interface OrdenCompraDownloadButtonProps {
    ordenId: string;
    pdfUrl?: string | null;
    visible: boolean;
    className?: string;
    id?: string;
    size?: 'sm' | 'md';
}

export const OrdenCompraDownloadButton: React.FC<OrdenCompraDownloadButtonProps> = ({
    ordenId,
    pdfUrl,
    visible,
    className = '',
    id = 'ot-orden-compra-download',
    size = 'sm',
}) => {
    if (!visible) {
        return null;
    }

    const href = pdfUrl || `/sittApi/solicitudesServicio/generar_orden_compra_pdf.php?id=${ordenId}`;
    const btnClass = size === 'sm' ? 'btn-sm' : '';

    return (
        <a
            id={id}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className={`btn ${btnClass} btn-outline-danger shadow-sm rounded-pill px-3 ${className}`.trim()}
            title="Descargar Orden de Compra vigente"
        >
            <i className="fas fa-file-pdf me-1" /> Orden de Compra
        </a>
    );
};
